import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[noSpace]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => NoSpaceValidationDirective),
    multi: true,
  }],
})
export class NoSpaceValidationDirective implements Validator {
  validate(control: AbstractControl): { [key: string]: any } | null {
    if (control.value) {
      if (control.value.toString() && control.value.toString().indexOf(' ') === -1) {
        return null;
      } else {
        return {
          noSpace: true,
        };
      }
    }
  }
}
